// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
 const { variant } = evt.detail; 
  const iWishBtn = document.querySelector('.iWishAddColl');

  if (iWishBtn && variant) {
    iWishBtn.setAttribute('data-variant', variant.id);
    iWishBtn.setAttribute('data-ptitle', evt.detail.productTitle || variant.name || '');
  }
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});



document.addEventListener('DOMContentLoaded', function() {
  const defaultSVG = `<span class="icon-default">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M 5 5 h 14 v 15 l -7 -4 l -7 4 Z m 1 1 v 12 L 12 15 l 6 3 V 6 Z" fill="currentcolor" stroke-miterlimit="10" stroke-width="1.2"></path>
      </svg>
    </span>`;
  const addedSVG = `<span class="icon-added">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M 5 5 h 14 v 15 l -7 -4 l -7 4 Z Z" fill="currentcolor" stroke-miterlimit="10" stroke-width="1.2"></path>
      </svg>
    </span>`;

  const initBtn = (btn) => {
    if (btn.dataset.iwishInit === "true") return;
    btn.dataset.iwishInit = "true";

    const fadeReplace = (newContent) => {
      setTimeout(() => {
        btn.innerHTML = newContent;
      }, 0);
    };

    const updateIcon = () => {
      if (btn.classList.contains('iwishAdded')) {
        fadeReplace(addedSVG);
      } else {
        fadeReplace(defaultSVG);
      }
    };

    updateIcon();

    const observer = new MutationObserver(updateIcon);
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  };

  // ilk butonları yükle
  document.querySelectorAll('.iWishAddColl').forEach(initBtn);

  // yeni butonlar eklenirse yakala
  const globalObserver = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches('.iWishAddColl')) {
          initBtn(node);
        } else if (node.nodeType === 1) {
          node.querySelectorAll && node.querySelectorAll('.iWishAddColl').forEach(initBtn);
        }
      });
    });
  });
  globalObserver.observe(document.body, { childList: true, subtree: true });
});

 